import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LogoMark } from "@/components/Logo";

const field = "w-full h-12 bg-[#0D0D11] border border-[#D4AF37]/25 px-4 text-[#F5F3EF] focus:outline-none focus:border-[#D4AF37] transition-colors";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center px-5">
      <form onSubmit={submit} className="w-full max-w-md border border-[#D4AF37]/25 bg-[#13141C] p-10" data-testid="admin-login-form">
        <LogoMark className="h-14 w-auto" />
        <h1 className="mt-8 font-display text-4xl text-[#F5F3EF]">Atlas admin</h1>
        <p className="mt-2 text-sm text-[#A09E97]">Sign in to manage the catalogue.</p>
        <label className="block mt-8 font-mono-j text-[11px] uppercase tracking-[0.2em] text-[#A09E97]">Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${field} mt-2`} data-testid="admin-login-email" />
        </label>
        <label className="block mt-5 font-mono-j text-[11px] uppercase tracking-[0.2em] text-[#A09E97]">Password
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={`${field} mt-2`} data-testid="admin-login-password" />
        </label>
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} data-testid="admin-login-submit"
          className="mt-8 w-full h-12 rounded-full bg-[#D4AF37] text-[#0D0D11] font-medium hover:bg-[#E5C158] disabled:opacity-60 transition-colors">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
